module.exports = __webpack_public_path__ + "media/เก่งแต่เรื่องคนอื่น.9ace12b4.mp3";